<template>
  <div class="home">
    <Hero :heading="heading"/>
    <p>I'm a software developer with an interest in all aspects of full-stack development &mdash; Reach out to me at <a href="mailto:contact@aidana.dev" class="p-link">contact@aidana.dev</a> or check out some of my <router-link to="/projects" class="p-link">projects!</router-link></p>
  </div>
</template>


<script>
import Hero from '@/components/Hero.vue'

export default {
  name: 'Home',
  components: {
    Hero,
  },
  data () {
    return {
      heading: `Hello!`,           
    }
  },
}
</script>

<style scoped>
p {
  margin: 0;
  color: var(--color-body);
  font-family: var(--primary-ff);
  font-weight: 500;
  font-size: var(--fs-3);
  line-height: 1.35em;
}

@media (max-width: 400px) {
  p {
    font-size: var(--fs-3m);
  }
}
</style>